import React from "react";
import { Button, Card, Col, Row } from "reactstrap";
import Layout, { Main } from "./Layout";
import styled from "styled-components";
import { colors, mediaQueries } from "./theme";

const MainTitle = styled.h1`
  font-family: Raleway;
  font-size: 2rem;
  color: ${({ theme }) => theme.textPrimary};
  ${mediaQueries.desktop} {
    font-size: 2.8rem;
  }
`;

const SecondaryTitle = styled.h2`
  color: ${({ theme }) => theme.textPrimary};
`;

const SectionWithBg = styled.section`
  background-color: ${({ theme }) =>
    theme.mode === "dark" ? theme.card : "#f8efe1"};
  margin-bottom: 40px;
  padding: 30px 0;
`;

const CustomParagraph = styled.p`
  margin-top: 15px;
  line-height: 1.4;
  ${mediaQueries.desktop} {
    margin-top: 65px;
  }
`;

const BirthdayCard = styled(Card)`
  display: flex;
  justify-content: center;
  background: #ffbd5a;
  background: linear-gradient(
    320deg,
    rgba(255, 189, 90, 0.99) 63%,
    rgba(173, 11, 3, 1) 92%,
    rgba(173, 11, 3, 0.97) 98%
  );
  background-repeat: no-repeat;
  height: 200px;
  width: 200px;
  text-align: center;
  border-radius: 50%;
`;
const BirtCard = styled(Card)`
  display: flex;
  justify-content: center;
  background: #ff66c4;
  background: linear-gradient(
    320deg,
    rgba(255, 102, 196, 0.99) 63%,
    rgba(173, 11, 3, 1) 92%,
    rgba(173, 11, 3, 0.97) 98%
  );
  background-repeat: no-repeat;
  height: 200px;
  width: 200px;
  text-align: center;
  border-radius: 50%;
`;

const NewYearCard = styled(Card)`
  display: flex;
  justify-content: center;
  background: #03bf63;
  background: linear-gradient(
    320deg,
    rgba(3, 191, 99, 0.99) 63%,
    rgba(173, 11, 3, 1) 92%,
    rgba(173, 11, 3, 0.97) 98%
  );
  background-repeat: no-repeat;
  height: 200px;
  width: 200px;
  text-align: center;
  border-radius: 50%;
`;
const WeddingCard = styled(Card)`
  display: flex;
  justify-content: center;
  background: #0397b2;
  background: linear-gradient(
    320deg,
    rgba(3, 151, 178, 0.99) 63%,
    rgba(173, 11, 3, 1) 92%,
    rgba(173, 11, 3, 0.97) 98%
  );
  background-repeat: no-repeat;
  height: 200px;
  width: 200px;
  text-align: center;
  border-radius: 50%;
`;
const AdsCard = styled(Card)`
  display: flex;
  justify-content: center;
  background: #cb6be6;
  background: linear-gradient(
    320deg,
    rgba(203, 107, 230, 0.99) 63%,
    rgba(173, 11, 3, 1) 92%,
    rgba(173, 11, 3, 0.97) 98%
  );
  background-repeat: no-repeat;
  height: 200px;
  width: 200px;
  text-align: center;
  border-radius: 50%;
`;

const CongratulateCard = styled(Card)`
  display: flex;
  justify-content: center;
  padding: 0 5px;
  background: #9afefb;
  background: linear-gradient(
    320deg,
    rgba(154, 254, 251, 0.99) 63%,
    rgba(173, 11, 3, 1) 92%,
    rgba(173, 11, 3, 0.97) 98%
  );
  background-repeat: no-repeat;
  height: 200px;
  width: 200px;
  text-align: center;
  border-radius: 50%;
`;
const BaptismCard = styled(Card)`
  display: flex;
  justify-content: center;
  background: #dfff99;
  background: linear-gradient(
    320deg,
    rgba(223, 255, 153, 0.99) 63%,
    rgba(173, 11, 3, 1) 92%,
    rgba(173, 11, 3, 0.97) 98%
  );
  background-repeat: no-repeat;
  height: 200px;
  width: 200px;
  text-align: center;
  border-radius: 50%;
`;

const OtherCard = styled(Card)`
  display: flex;
  justify-content: center;
  background: #d29aff;
  background: linear-gradient(
    320deg,
    rgba(210, 154, 255, 0.99) 63%,
    rgba(173, 11, 3, 1) 92%,
    rgba(173, 11, 3, 0.97) 98%
  );
  background-repeat: no-repeat;
  height: 200px;
  width: 200px;
  text-align: center;
  border-radius: 50%;
`;

const ScrollingRow = styled(Row)`
  overflow: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const AboutUs = () => {
  return (
    <Layout backPath={{ pathname: "/" }}>
      <Main className={"my-4"}>
        <Row
          className={
            "d-flex flex-column flex-md-row justify-content-md-between align-items-center"
          }
        >
          <Col sm={12} md={5}>
            <MainTitle>
              Allodedicace, plateforme de dédicace personnalisée
            </MainTitle>
            <p class={"my-4"}>
              Dédicace vidéo, dédicace musicale et dédicace business pour vous
              et proches par vos célébrités préférée. Allodedicace est un vrai
              facilitateur de contact avec les célébrités
            </p>
            <Button color={"primary"} href={"/"} tag={"a"}>
              Voir nos célébrités
            </Button>
          </Col>
          <Col className={"mt-3 mt-md-0"} sm={12} md={7}>
            <img
              width={"100%"}
              src="image_filles_emues.png"
              alt="image_filles_emues"
            />
          </Col>
        </Row>
      </Main>
      <SectionWithBg>
        <Main>
          <Row>
            <Col>
              <SecondaryTitle>Que propose allodedicace ?</SecondaryTitle>
            </Col>
          </Row>
          <Row
            className={
              "d-flex flex-column flex-md-row justify-content-md-between align-content-md-start"
            }
          >
            <Col sm={12} md={5}>
              <CustomParagraph className={"fs-3"}>
                AlloDedicace facilite le rapprochement entre célébrités/idoles
                et fans via un site internet.
              </CustomParagraph>
            </Col>
            <Col sm={12} md={6}>
              <img width={"100%"} src="world_map.png" alt="" />
            </Col>
          </Row>
          <Row className={"justify-content-center"}>
            <Col sm={12} md={7}>
              <p className={"fs-3"}>
                C’ est une occasion unique et exceptionnelle de pouvoir
                commander des services divers à des célébrités/idoles préférées,
                de partout dans le monde.
              </p>
            </Col>
          </Row>
        </Main>
      </SectionWithBg>
      <Main>
        <Row className={"mb-5"}>
          <Col sm={12} md={6}>
            <SecondaryTitle>
              A quelle occasion peut-on demander des dédicaces
              personnalisées&nbsp;?
            </SecondaryTitle>
          </Col>
        </Row>
        <ScrollingRow
          className={
            "d-flex justify-content-md-center flex-row flex-nowrap flex-md-wrap mb-3"
          }
        >
          <Col
            xs={8}
            md={3}
            className={"mb-3 d-flex justify-content-md-center"}
          >
            <BirthdayCard>
              <p className={"fs-5 mb-0 px-1"}>Anniversaire</p>
            </BirthdayCard>
          </Col>
          <Col
            xs={8}
            md={3}
            className={"mb-3 d-flex justify-content-md-center"}
          >
            <BirtCard>
              <p className={"fs-5 mb-0 px-1"}>Naissance</p>
            </BirtCard>
          </Col>
          <Col
            xs={8}
            md={3}
            className={"mb-3 d-flex justify-content-md-center"}
          >
            <NewYearCard>
              <p className={"fs-5 mb-0 px-1"}>Fête de fin d'année</p>
            </NewYearCard>
          </Col>
          <Col
            xs={8}
            md={3}
            className={"mb-3 d-flex justify-content-md-center"}
          >
            <WeddingCard>
              <p className={"fs-5 mb-0 px-1"}>Mariage</p>
            </WeddingCard>
          </Col>
          <Col
            xs={8}
            md={3}
            className={"mb-3 d-flex justify-content-md-center"}
          >
            <AdsCard>
              <p className="fs-5 mb-0 px-1">Publicité pour votre business</p>
            </AdsCard>
          </Col>
          <Col
            xs={8}
            md={3}
            className={"mb-3 d-flex justify-content-md-center"}
          >
            <CongratulateCard>
              <p className="fs-5 mb-0 px-1">Félicitation et encouragement</p>
            </CongratulateCard>
          </Col>
          <Col
            xs={8}
            md={3}
            className={"mb-3 d-flex justify-content-md-center"}
          >
            <BaptismCard>
              <p className="fs-5 mb-0 px-1">Baptème</p>
            </BaptismCard>
          </Col>
          <Col
            xs={8}
            md={3}
            className={"mb-3 d-flex justify-content-md-center"}
          >
            <OtherCard>
              <p className="fs-5 mb-0 px-1">Et d'autres occasions</p>
            </OtherCard>
          </Col>
        </ScrollingRow>
      </Main>
      <SectionWithBg>
        <Main>
          <Row>
            <Col sm={12} md={6}>
              <SecondaryTitle>
                Sous quelle forme se présente la dédicace personnalisée&nbsp;?
              </SecondaryTitle>
            </Col>
          </Row>
          <Row className={"mt-4"}>
            <Col sm={12} md={6}>
              <p className={"fs-3"}>
                Vos célébrités présentes sur allodédicace proposent trois types
                de produits de dédicace :
              </p>
              <ul className={"fs-3"}>
                <li>les dédicaces vidéos</li>
                <li>les dédicaces musicales</li>
                <li>les vidéos business</li>
              </ul>
            </Col>
          </Row>
          <Row>
            <Col>
              <p className={"fs-3"}>
                Ainsi, quelle que soit l'occasion que vous avez choisie, vous
                pouvez formuler un message que votre célébrité/idole va produire
                en message vidéo ou en parole dans une chanson, pour vous ou
                pour vos proches.
              </p>
            </Col>
          </Row>
        </Main>
      </SectionWithBg>
      <Main>
        <section>
          <Row>
            <Col>
              <SecondaryTitle>Les dédicaces vidéos</SecondaryTitle>
            </Col>
          </Row>
          <Row className={"d-flex align-items-start mt-4"}>
            <Col sm={12} md={4}>
              <img
                src="video_dedicace_illustration.jpeg"
                alt="illustration dedicace video"
                width={"100%"}
              />
            </Col>
            <Col m={12} md={7}>
              <p className={"fs-3 mt-4 mt-md-0"}>
                Pour diverses occasions, envoyez un message écrit à votre
                célébrité préférée sur allodedicace.com.
              </p>
              <p className={"fs-3"}>
                Il se chargera d'être votre porte voix en lisant votre message
                dans une vidéo soignée, exploitable et libre de droit.
              </p>
              <p className={"fs-3"}>
                Il envoie la vidéo réalisée à une adresse mail que vous lui
                aurez indiquez (votre adresse mail ou celle d'un proche
                destinataire du message).
              </p>
            </Col>
          </Row>
        </section>
        <hr />
        <section className={"mt-5"}>
          <Row>
            <SecondaryTitle>Les dédicaces musicales</SecondaryTitle>
          </Row>
          <Row className={"mt-4"}>
            <Col sm={12} md={7}>
              <p className={"fs-3"}>
                Pour votre image ou celle d'un proche, demandez une dédicace
                musicale à votre artiste chanteur préféré. Envoyez un message
                indiquant ce que vous voulez que l'artiste dise de vous dans une
                nouvelle chanson ou dans une remix. Il chante votre message en
                rendant hommage à vous ou au bénéficiaire final de votre
                message.
              </p>
              <p className={"fs-3"}>
                A la sortie de la chanson, vous recevez copie par mail pour une
                exploitation conforme aux droits d'auteurs indiqués par
                l'artiste.
              </p>
            </Col>
            <Col sm={12} md={4}>
              <img
                src="music_dedicace_illustration.jpeg"
                alt="illustration dedicace musicale"
                width={"100%"}
              />
            </Col>
          </Row>
        </section>
        <hr />
        <section className={"mt-5"}>
          <Row>
            <SecondaryTitle>Les vidéos business</SecondaryTitle>
          </Row>
          <Row className={"mt-4"}>
            <Col sm={12} md={4}>
              <img
                src="business_video_illustration.jpeg"
                alt="illustration video business"
                width={"100%"}
              />
            </Col>
            <Col sm={12} md={7}>
              <p className={"fs-3 mt-4 mt-md-0"}>
                Vous avez une activité, une initiative ou un business et
                souhaitez lui donnez plus de visibilité afin d'accroître les
                résultats attendus ? Sachez que vos célébrités peuvent vous
                aider en présentant dans une vidéo, un message qui fasse la
                promotion de votre projet, business ou initiative.
              </p>
              <p className="fs-3">
                Pour ce faire, préparez votre message et commandez le service à
                la célébrité de votre choix sur allodedicace.com.
              </p>
            </Col>
          </Row>
        </section>
      </Main>
    </Layout>
  );
};

export default AboutUs;
